import pLogo from 'assets/images/p-logo.svg';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import ExpandIcon from '../../../components/common/ExpandIcon';
import { settledBetDetails } from '../../../modules/analytics/actions';
import { collapse, expand } from '../../../utils/transition';
import { attempt as transferAttempt } from '../../transfer/actions';
import { getSingleSelectionLabel, makeGetFormattedBet } from '../selectors';
import Selection from './Selection';

class Bet extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      expanded: false
    };
  }

  toggle() {
    const { expanded } = this.state;
    const { showDetails, betStake, betType, isoBetPlacedTime, selectionLabel } = this.props;

    this.setState({ expanded: !expanded });
    if (expanded) {
      collapse(this, 'settled-bet__selections--expanded');
    } else {
      showDetails({
        betPlacedTime: isoBetPlacedTime,
        betStake,
        betType,
        selectionLabel
      });
      expand(this, 'settled-bet__selections--expanded');
    }
  }

  render() {
    const {
      betPlacedTime,
      betCashedInTime,
      betPayoutFormatted,
      betStake,
      betStakePerLine,
      betType,
      slipId,
      cashedOut,
      selections,
      fundingType,
      allowTransfer,
      transferSlip
    } = this.props;
    const { expanded } = this.state;
    const plusBet = fundingType === 'PLUS';
    const plusIcon = plusBet && (
      <img src={pLogo} className="settled-bet__returns-img" />
    );

    return (
      <div
        className={classnames('settled-bet', {
          'settled-bet--expanded': expanded
        })}
      >
        <main className="settled-bet__main" onClick={this.toggle}>
          <div className="settled-bet__select-button">
            <ExpandIcon expanded={expanded} />
          </div>
          <div className="settled-bet__header">
            {betStakePerLine} {betType}
          </div>
          <ul className="settled-bet__fields-list">
            <li className="settled-bet__field">
              <div className="settled-bet__field-label">Placed</div>
              <div className="settled-bet__field-value">{betPlacedTime}</div>
            </li>
            <li className="settled-bet__field">
              <div className="settled-bet__field-label">Slip</div>
              <div className="settled-bet__field-value">
                {slipId}
              </div>
            </li>
            <li className="settled-bet__field">
              <div className="settled-bet__field-label">Stake</div>
              <div className="settled-bet__field-value">{betStake}</div>
            </li>
            <li className="settled-bet__field settled-bet__field--cashed-in">
              <div className="settled-bet__field-label">
                {cashedOut ? 'Cashed in' : 'Returns'}
              </div>
              <div className="settled-bet__field-value">
                {plusIcon}{betPayoutFormatted}
                {betCashedInTime ? ` - ${betCashedInTime}` : ''}
              </div>
            </li>
          </ul>
        </main>
        <div
          className="settled-bet__selections"
          ref={(ref) => {
            this.contentNode = ref;
          }}
        >
          <ul className="settled-bet__selections-list">
            {
              selections.map(selectionUniqueId => (
                <Selection selectionUniqueId={selectionUniqueId} key={selectionUniqueId} />
              ))
            }
          </ul>
        </div>
        {allowTransfer && (
          <div className="settled-bet__footer">
            <Button className="settled-bet__transfer-button" onClick={() => transferSlip(slipId)}>
              Transfer to Online
            </Button>
          </div>
        )}
      </div>
    );
  }
}

Bet.propTypes = {
  betPlacedTime: PropTypes.string.isRequired,
  isoBetPlacedTime: PropTypes.string.isRequired,
  betCashedInTime: PropTypes.string,
  betPayoutFormatted: PropTypes.string.isRequired,
  betStake: PropTypes.string.isRequired,
  selectionLabel: PropTypes.string,
  betStakePerLine: PropTypes.string.isRequired,
  betType: PropTypes.string.isRequired,
  slipId: PropTypes.string.isRequired,
  cashedOut: PropTypes.bool.isRequired,
  selections: PropTypes.object.isRequired,
  showDetails: PropTypes.func.isRequired,
  fundingType: PropTypes.string.isRequired,
  allowTransfer: PropTypes.bool.isRequired,
  transferSlip: PropTypes.func.isRequired
};

const makeMapStateToProps = (initialState, initialProps) => {
  const getFormattedBet = makeGetFormattedBet();
  // removed due to live issue / const allowTransferAttempt = makeAllowTransferAttempt();
  return (state) => {
    const {
      betPlacedTime,
      isoBetPlacedTime,
      betCashedInTime,
      betPayoutFormatted,
      betStake,
      betStakePerLine,
      betType,
      slipId,
      cashedOut,
      selections,
      fundingType
    } = getFormattedBet(state, initialProps);
    return {
      betPlacedTime,
      isoBetPlacedTime,
      betCashedInTime,
      betPayoutFormatted,
      betStake,
      betStakePerLine,
      betType,
      slipId,
      cashedOut,
      fundingType,
      selections,
      selectionLabel: getSingleSelectionLabel(state, initialProps),
      allowTransfer: false // removed due to live issue / allowTransferAttempt(state, initialProps)
    };
  };
};

const mapDispatchToProps = {
  showDetails: settledBetDetails,
  transferSlip: transferAttempt
};

export default connect(makeMapStateToProps, mapDispatchToProps)(Bet);
